import React from 'react';
import { Route, Switch } from 'react-router';
// const PDFS = lazy(() => import('./PDFs'));
import PDFS from './PDFs';

const Compare: React.FC = () => {
  return (
    <Switch>
      <Route
        path={'/compare/pdfs'}
        exact
        render={() => {
          return <PDFS />;
        }}
      />
    </Switch>
  );
};

export default Compare;
